import React from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';
import Charts from './Charts';

const ChartModal = (props) => {
  const {
    filteredData,
    chartMeta,
    closeChart,
    rawData,
  } = props;

  const Chart = Charts[chartMeta.type];

  return (
    <div className="chart-modal">
      <Modal
        closeOnOutsideClick
        onClose={closeChart}
        header={<h2>{chartMeta.title}</h2>}
      >
        <div className="chart-modal__wrapper">
          <Chart
            rawData={rawData}
            filteredData={filteredData}
            chartMeta={chartMeta}
          />
        </div>
      </Modal>
    </div>
  );
};

ChartModal.propTypes = {
  chartMeta: PropTypes.objectOf(PropTypes.shape),
  closeChart: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  filteredData: PropTypes.arrayOf(PropTypes.object),
  // eslint-disable-next-line react/forbid-prop-types
  rawData: PropTypes.arrayOf(PropTypes.object),
};

export default ChartModal;
